"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Lang_js_1 = require("../Lang.js");
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var LivestreamAttendanceMap_1 = __importDefault(require("./LivestreamAttendanceMap"));
// Force all <a> tags in admin-provided HTML to open in a new tab, so taps on
// links inside livestream tabs (Seed, Chat, Calendar, FAQ, Handouts, Zoom)
// don't navigate the page away from the live meeting. Skips anchors that
// already have a target= attribute set by the admin.
var withTargetBlank = function (html) {
    if (!html)
        return '';
    return html.replace(/<a\b([^>]*)>/gi, function (match, attrs) {
        if (/\btarget\s*=/i.test(attrs))
            return match;
        return "<a".concat(attrs, " target=\"_blank\" rel=\"noopener noreferrer\">");
    });
};
function LivestreamContent(requestLivestream, activeTab, setActiveTab, trackAttendance, attendanceMessage, statistics, setStatistics, pollInterval, setPollInterval) {
    var _a, _b, _c, _d, _e, _f;
    var googleKey = (_b = (_a = document.getElementById('livestream-info')) === null || _a === void 0 ? void 0 : _a.dataset['google-key']) !== null && _b !== void 0 ? _b : null;
    function doTrackAttendance(attendanceCount, requestLivestream) {
        // NaN must be caught explicitly: `NaN < 1` is false, so a bare range check lets it
        // through, and JSON.stringify then serialises it as null — which the server rejects
        // as a missing required field. One viewer, one attendee is the safe assumption.
        if (!Number.isFinite(attendanceCount) || attendanceCount < 1) {
            attendanceCount = 1;
        }
        var url_base = '/api/livestream/attendance';
        axios_1.default
            .get('/api/v2/students/status')
            .then(function (__) {
            url_base = '/api/livestream/login_attendance';
            sendAttendance(attendanceCount, requestLivestream, url_base);
        })
            .catch(function () {
            sendAttendance(attendanceCount, requestLivestream, url_base);
        });
    }
    function sendAttendance(attendanceCount, requestLivestream, url_base) {
        axios_1.default
            .post(url_base, {
            viewer_count: parseInt(String(attendanceCount)),
            livestream_id: parseInt(String(requestLivestream.id)),
        })
            .then(function (response) {
            console.log(response);
        })
            .catch(function (error) {
            var _a, _b;
            // Attendance is a courtesy count, so a failure is never surfaced to the viewer
            // mid-meeting. It must still be loud in the console: a silent catch here hid a
            // 77% rejection rate across the 2026-08-23 meeting.
            console.error('livestream attendance submission failed', (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : error);
        });
    }
    var attendanceModalOpen = false;
    var pageAccessedByReload = (window.performance.navigation &&
        window.performance.navigation.type ===
            performance.navigation.TYPE_RELOAD) ||
        window.performance
            .getEntriesByType('navigation')
            .map(function (nav) { return nav.type; })
            .includes('reload');
    if (!pageAccessedByReload) {
        attendanceModalOpen = trackAttendance;
    }
    return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column' }, className: "container" },
        react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h2", sx: { alignSelf: 'center' } }, requestLivestream.title),
        react_1.default.createElement(material_1.Box, { className: "video-chat-container", sx: { display: 'flex', flexGrow: 1 } },
            react_1.default.createElement(material_1.Box, { className: "livestream-video-code" }, requestLivestream.emergency_slide ? (react_1.default.createElement("img", { src: requestLivestream.emergency_slide, alt: "Emergency Slide" })) : requestLivestream.zoom_only ? (react_1.default.createElement(material_1.Box, { sx: { textAlign: 'center', mt: '50px' } },
                react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h2" }, (0, Lang_js_1.__)('This event is on ZOOM')),
                react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h3" }, (0, Lang_js_1.__)('Please use the information below to access the Zoom meeting.')),
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Typography, null,
                        react_1.default.createElement("strong", null, (0, Lang_js_1.__)('Zoom Meeting ID:')),
                        ' ',
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (_c = requestLivestream.zoom_only_id) !== null && _c !== void 0 ? _c : '' } })),
                    react_1.default.createElement(material_1.Typography, null,
                        react_1.default.createElement("strong", null, (0, Lang_js_1.__)('Zoom Meeting Password:')),
                        ' ',
                        react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (_d = requestLivestream.zoom_only_password) !== null && _d !== void 0 ? _d : '' } })),
                    react_1.default.createElement(material_1.Typography, null,
                        react_1.default.createElement(material_1.Link, { href: (_e = requestLivestream.zoom_only_link) !== null && _e !== void 0 ? _e : '#', target: "_blank", rel: "noopener noreferrer", className: "black-link", underline: "hover" }, (0, Lang_js_1.__)('Zoom Meeting Link')))))) : (react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: (_f = requestLivestream.video_code) !== null && _f !== void 0 ? _f : '' } }))),
            react_1.default.createElement(material_1.Box, { className: "livestream-chat-code" },
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center' } },
                    requestLivestream.chat_code && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('chat'); } }, (0, Lang_js_1.__)('Chat'))),
                    requestLivestream.give_code && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('give'); } }, (0, Lang_js_1.__)('Seed'))),
                    requestLivestream.event_information && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('info'); } }, (0, Lang_js_1.__)('Calendar'))),
                    requestLivestream.faq && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('faq'); } }, (0, Lang_js_1.__)('FAQ')))),
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center', mt: '1px' } },
                    requestLivestream.zoom_link && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('zoom'); } }, (0, Lang_js_1.__)('Join Zoom Room'))),
                    requestLivestream.handouts && (react_1.default.createElement(material_1.Button, { onClick: function () { return setActiveTab('handouts'); } }, (0, Lang_js_1.__)('Handouts')))),
                activeTab === 'chat' && (react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.chat_code) } })),
                activeTab === 'info' && (react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.event_information) } }))),
                activeTab === 'faq' && (react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.faq) } }))),
                activeTab === 'give' && (react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.give_code) } }))),
                activeTab === 'handouts' && (react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.handouts) } }))),
                activeTab === 'zoom' && (react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Box, { dangerouslySetInnerHTML: { __html: withTargetBlank(requestLivestream.zoom_link) } }))))),
        react_1.default.createElement(material_1.Box, { className: "livestream-attendance", sx: { display: 'flex', flexGrow: 1 } }, statistics.length > 0 && (react_1.default.createElement(LivestreamAttendanceMap_1.default, { statistics: statistics, title: (0, Lang_js_1.__)('Send Light to our Global Community'), googleKey: googleKey }))),
        react_1.default.createElement(material_1.Modal, { id: "attendanceModal", open: attendanceModalOpen, onClose: function () {
                attendanceModalOpen = false;
                document.body.style.overflow = 'auto';
            }, "aria-label": attendanceMessage, "aria-describedby": "modal-modal-description" },
            react_1.default.createElement(material_1.Box, { sx: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '1px solid #000',
                    boxShadow: 24,
                    p: 4,
                } },
                react_1.default.createElement(material_1.Typography, { id: "modal-modal-description", sx: { mt: 2 } }, attendanceMessage),
                react_1.default.createElement("input", { id: "attendanceCount", name: "attendanceCount", defaultValue: "1", inputMode: "numeric", pattern: "[0-9]*", "aria-label": (0, Lang_js_1.__)('Input the number of participants'), placeholder: "1", autoFocus: true, onLoad: function (e) {
                        e.target.select();
                    }, onClick: function (e) {
                        e.target.placeholder = '';
                        e.target.select();
                    }, onBlur: function (e) {
                        e.target.placeholder = '1';
                    }, maxLength: 2, style: {
                        width: '4em',
                        padding: '1em',
                        fontSize: 'large',
                    } }),
                react_1.default.createElement(material_1.Button, { onClick: function () {
                        var attendanceCountEl = document.getElementById('attendanceCount');
                        // `||` rather than `??` — a cleared field is an empty string, which `??`
                        // passes straight through to parseInt and turns into NaN.
                        var attendanceCount = parseInt((attendanceCountEl === null || attendanceCountEl === void 0 ? void 0 : attendanceCountEl.value) || '1', 10);
                        doTrackAttendance(attendanceCount, requestLivestream);
                        attendanceModalOpen = false;
                        document.body.style.overflow = 'auto';
                        var modalEl = document.getElementById('attendanceModal');
                        if (modalEl) {
                            modalEl.style.display = 'none';
                        }
                        return true;
                    }, variant: "contained", color: "primary", sx: { mt: '1em' } }, (0, Lang_js_1.__)('Submit')),
                react_1.default.createElement(material_1.Typography, { sx: {
                        mt: 2,
                        fontSize: 'small',
                        textAlign: 'center',
                    } },
                    react_1.default.createElement(material_1.Link, { href: "#", underline: "hover", onClick: function () {
                            attendanceModalOpen = false;
                            document.body.style.overflow = 'auto';
                            var modalEl = document.getElementById('attendanceModal');
                            if (modalEl) {
                                modalEl.style.display = 'none';
                            }
                            return true;
                        } }, (0, Lang_js_1.__)('SKIP, I have already responded for this event')))))));
}
exports.default = LivestreamContent;
